import { Box, styled } from '@mui/material';

const Container = styled(Box)({
  height: '70vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
});

export { Container };
